import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const faqs = [{
    q: '¿Y si no me funciona?',
    a: 'Si haces el RU cuando aparece el impulso, ya ganaste. No buscamos perfección; buscamos cortar el ciclo.'
  }, {
    q: '¿Y si lloro?',
    a: 'Entonces estás viva. Llora con estructura, no con el teléfono en la mano.'
  }, {
    q: '¿Y si ya recaí hoy?',
    a: 'Perfecto. Estás en el punto exacto donde un protocolo importa.'
  }];
  const handleAddToCart = () => {
    trackAddToCart();
  };
  return <section id="pricing" className="py-24 px-6 relative" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative mb-24" data-id="element-187">
          {/* Glow behind card */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#E8636F] to-[#F4A261] opacity-20 blur-[60px] rounded-3xl" data-id="element-188"></div>

          <div className="relative glass-card p-8 md:p-12 rounded-3xl text-center border border-white/10" data-id="element-189">
            {/* Discount Badge */}
            <motion.div initial={{
            scale: 0
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            type: 'spring',
            bounce: 0.5,
            delay: 0.3
          }} className="absolute -top-4 left-1/2 -translate-x-1/2 inline-flex items-center px-4 py-1.5 rounded-full bg-gradient-to-r from-[#E8636F] to-[#F4A261] text-white text-sm font-bold tracking-wide shadow-lg shadow-[#E8636F]/30" data-id="element-190">
              🔥 47% OFF — Oferta limitada
            </motion.div>

            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-2 mt-4" data-id="element-191">
              No Contact, <span className="text-gradient" data-id="element-192">Sin</span> Recaídas
            </h2>
            <p className="text-[#A8A8B3] text-lg mb-8" data-id="element-193">
              14 días de estructura para tu paz mental
            </p>

            <div className="flex flex-col items-center gap-2 mb-2" data-id="element-194">
              <div className="flex items-center gap-3" data-id="element-195">
                <span className="text-2xl text-[#A8A8B3]/50 line-through font-heading font-bold" data-id="element-196">
                  $12
                </span>
                <span className="text-xs font-bold tracking-wide uppercase px-2 py-0.5 rounded bg-[#E8636F]/20 text-[#E8636F]" data-id="element-197">
                  Ahorra $5.64
                </span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-198">
                <span className="text-6xl md:text-7xl font-heading font-extrabold text-gradient tracking-tight" data-id="element-199">
                  $6.36
                </span>
                <span className="text-xl text-[#A8A8B3] self-end mb-4" data-id="element-200">
                  USD
                </span>
              </div>
            </div>

            <p className="text-[#A8A8B3] mb-10" data-id="element-201">
              Menos que un café con leche… y esto te ahorra semanas de ansiedad.
            </p>

            <Button fullWidth href="https://momentumdigitalpro.com/cart/44432911138918:1" onNavigate={handleAddToCart} className="py-5 text-xl mb-6" data-id="element-202">
              Quiero empezar hoy
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-sm text-[#A8A8B3]" data-id="element-203">
              <span className="flex items-center gap-1" data-id="element-204">
                <CheckIcon className="w-4 h-4 text-[#5BB5A2]" data-id="element-205" /> Descarga
                inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-206">
                <CheckIcon className="w-4 h-4 text-[#5BB5A2]" data-id="element-207" /> PDF + Digital
              </span>
              <span className="flex items-center gap-1" data-id="element-208">
                <CheckIcon className="w-4 h-4 text-[#5BB5A2]" data-id="element-209" /> Acceso de por
                vida
              </span>
            </div>
          </div>
        </motion.div>

        {/* FAQ */}
        <div className="max-w-2xl mx-auto mb-24" data-id="element-210">
          <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-211">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-4" data-id="element-212">
            {faqs.map((faq, index) => <div key={index} className="glass-card rounded-xl overflow-hidden" data-id="element-213">
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full p-6 flex justify-between items-center text-left hover:bg-white/5 transition-colors" data-id="element-214">
                  <span className="font-bold text-white" data-id="element-215">{faq.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#A8A8B3] transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-216" />
                </button>
                <AnimatePresence data-id="element-217">
                  {openFaq === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-218">
                      <div className="px-6 pb-6 text-[#A8A8B3] leading-relaxed" data-id="element-219">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>

      {/* Final CTA Banner */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-[#0F0F14]/90 backdrop-blur-lg border-t border-white/10 md:hidden z-40" data-id="element-220">
        <Button fullWidth href="https://momentumdigitalpro.com/cart/44432911138918:1" onNavigate={handleAddToCart} data-id="element-221">
          Empieza con el Día 1 hoy
        </Button>
      </div>

      <div className="hidden md:block text-center pb-12" data-id="element-222">
        <Button href="https://momentumdigitalpro.com/cart/44432911138918:1" onNavigate={handleAddToCart} className="px-12 py-4" data-id="element-223">
          Empieza con el Día 1 hoy
        </Button>
      </div>
    </section>;
}